module.exports = __webpack_public_path__ + "assets/img/172-6C6D LaVille-v6-3333-1.e609210f.jpg";